import { useNavigate } from "react-router-dom";
import { ArrowRight, Search } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function FinalCTA() {
  const navigate = useNavigate();
  return (
    <section className="bg-[#FAFAF8] pb-20" data-testid="final-cta-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="relative rounded-[28px] overflow-hidden">
          <img
            src="https://images.pexels.com/photos/33575697/pexels-photo-33575697.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1800"
            alt=""
            className="img-cover absolute inset-0"
          />
          <div className="absolute inset-0 hero-overlay" />
          <div className="relative px-8 md:px-16 py-16 md:py-20 text-[#FAFAF8] flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div>
              <div className="kicker text-[#F4A930] mb-4">Your next celebration</div>
              <h2 className="font-sora text-3xl md:text-5xl font-semibold tracking-tight leading-[1.05] max-w-2xl">
                Ready for your next celebration?
              </h2>
              <p className="mt-4 max-w-lg text-[#FAFAF8]/85 text-base md:text-lg">
                Search 30+ curated farmhouses around Hyderabad. Our host desk replies in under 30 minutes.
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Button
                onClick={() => navigate("/stays")}
                className="bg-[#F4A930] hover:bg-[#d99825] text-[#0E2E24] rounded-full px-7 py-6 font-sora font-semibold gap-2"
                data-testid="final-cta-search"
              >
                <Search size={16} /> Search Stays
              </Button>
              <Button
                variant="outline"
                onClick={() => navigate("/partner")}
                className="rounded-full px-7 py-6 border-[#FAFAF8]/30 text-[#FAFAF8] bg-transparent hover:bg-[#FAFAF8]/10 font-sora font-medium gap-2"
                data-testid="final-cta-partner"
              >
                Partner With Us <ArrowRight size={15} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
